// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2Heck","item":"PaymentsMobile_item__1Vmla","label":"PaymentsMobile_label__39GHo","amount":"PaymentsMobile_amount__2A4nG"};